<!-- カード番号 -->
<template>
  <div class="column">
    <label class="name">カード番号</label>
    <div class="value">{{ cardNo }}</div>
  </div>
</template>

<script>
export default {
  name: "PaymentCardnumber",
  props: {
    cardNo: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.column {
  display: flex;
  margin-bottom: 20px;
  font-size: 14px;
}

.column label {
  width: 110px;
  font-weight: normal;
  color: #888888;
}

.column .value {
  width: calc(100% - 110px);
  font-weight: bold;
}
</style>
